import { createFileRoute } from '@tanstack/react-router';
import { JourneyTypeFormPage } from '@/components/journeys/JourneyTypeFormPage.tsx';

export const Route = createFileRoute('/_app/journey-types/new')({
  staticData: { orgScope: 'required' },
  component: () => <JourneyTypeFormPage />,
});
